import { render, staticRenderFns } from "./proabono.vue?vue&type=template&id=208beb5f"
import script from "./proabono.vue?vue&type=script&lang=ts"
export * from "./proabono.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208beb5f')) {
      api.createRecord('208beb5f', component.options)
    } else {
      api.reload('208beb5f', component.options)
    }
    module.hot.accept("./proabono.vue?vue&type=template&id=208beb5f", function () {
      api.rerender('208beb5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/proabono.vue"
export default component.exports